import queryString from 'query-string';

export const urlWithQuery = (url: string, query: object): string => {
  const stringifiedQuery = queryString.stringify(query, { arrayFormat: 'bracket' });

  return stringifiedQuery ? `${url}?${stringifiedQuery}` : url;
};
